export enum QualityCheckStatus {
  WAITING_FOR_FORMAL_CONTROL = 'waiting_for_formal_control',
  WAITING = 'waiting',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}
